import {render} from "@variocube/app-ui";
import React from "react";
import {App} from "./App";
import {getStage} from "./stage";

render(<App stage={getStage()} />);
